import { useMemo } from 'react';
import { ActuatorTypes, QueryParams } from 'src/actuators/user-input/calculations/constants';
import { UserInput } from 'src/actuators/user-input/types';
import { isFilled } from 'src/actuators/user-input/utils/isFilled';
import { RegionsEnum } from 'src/generated/operations';

type Props = {
    selectedActuatorType: ActuatorTypes;
    state: UserInput;
    searchParams: URLSearchParams;
    currentRegion: RegionsEnum;
}

export const useActuatorCheckUserInputValid = ({
    selectedActuatorType,
    state,
    searchParams,
    currentRegion,
}: Props) => {
    const isFormFilled = useMemo(() => isFilled({
        selectedActuatorType,
        inputState: state,
        currentRegion,
    }), [currentRegion, selectedActuatorType, state]);

    const emptyResult = useMemo(() => searchParams.get(QueryParams.labels) === null &&
        searchParams.get(QueryParams.forces) === null &&
        searchParams.get(QueryParams.torques) === null &&
            isFormFilled, [isFormFilled, searchParams]);

    return { isFormFilled, emptyResult };
};
